// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"502":"ucare-panel-chunk","868":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"502":"0b1f9319","609":"1207e05d","868":"530043fb","929":"020c4ca7"}[chunkId] + ".chunk.js";
};